import { cn } from "@/lib/utils";
export function SettingsCard({ id, title, description, action, children, className, rootClassName, divide = false, flush = false, testid }) {
  return (
    <section id={id} className={cn("flex flex-col gap-2.5", rootClassName)} data-testid={testid}>
      {(title || action) && (
        <div className="flex items-end justify-between gap-3">
          <div>
            {title && <h2 className="text-base font-semibold text-foreground">{title}</h2>}
            {description && <p className="text-xs text-muted-foreground">{description}</p>}
          </div>
          {action && <div className="ml-auto">{action}</div>}
        </div>
      )}
      <div
        className={cn(
          "flex flex-col gap-4 rounded-xl border border-border bg-background",
          flush ? "overflow-hidden p-0" : "p-4",
          divide && "gap-0 divide-y divide-border [&>*]:py-3 [&>*:first-child]:pt-0 [&>*:last-child]:pb-0",
          className,
        )}
      >
        {children}
      </div>
    </section>
  );
}
export function SettingsControlRow({ label, description, control, className }) {
  return (
    <div className={cn("flex items-center justify-between gap-4", className)}>
      <div className="flex min-w-0 flex-col gap-0.5">
        <p className="text-sm font-medium text-foreground">{label}</p>
        {description && <div className="text-xs text-muted-foreground">{description}</div>}
      </div>
      {control}
    </div>
  );
}
